import { COLORS } from "../utils/colors";
import { resolveCSSVariable } from "../utils/cssVariableResolver";

export const REFSIX_GREEN = COLORS.green;
export const YELLOW_CARD = "#F9D401";
export const RED_CARD = "#930303";
export const YELLOW_CARD_GRAPH = "#f9d401";
export const RED_CARD_GRAPH = "#f60f49";

export const COLORS_DISTANCE = [
    COLORS.green,
    COLORS.yellow,
    COLORS.orange,
    COLORS.red,
    COLORS.purple,
    COLORS.blue,
];
export const COLORS_SPEED_CATEGORY = [
    COLORS.green,
    COLORS.yellow,
    COLORS.orange,
    COLORS.red,
];
export const COLORS_SPRINT_CATEGORY = [
    COLORS.yellow,
    COLORS.orange,
    COLORS.red,
];
export const COLORS_HEART_RATE_ZONES = [
    "#f5e737",
    "#ffce00",
    "#ff9a00",
    "#ff5a00",
    "#d00000",
];

export const COLORS_HEART_RATE_LINE = "#d00000";
export const COLORS_HEART_RATE_SHADING = "#d0000030";

export const COLORS_GOALS = ["#0EAA0B", "#f442d7"];
export const COLORS_WINS = [COLORS.green, COLORS.yellow, COLORS.red];
export const COLORS_HEART_RATE = [COLORS.red, COLORS.green];
export const COLORS_YELLOW_CARDS = [
    "#FFC80F",
    "#FFD310",
    "#FFDF11",
    "#FFEB12",
    "#FFF714",
];
export const COLORS_RED_CARDS = [
    "#750200",
    "#970E11",
    "#BA1A23",
    "#DC2634",
    "#FF3346",
];

export const GREEN_GRADIENT = [
    "var(--scorza-green-step1)",
    "var(--scorza-green-step2)",
    "var(--scorza-green-step3)",
    "var(--scorza-green-step4)",
    "var(--scorza-green-step5)",
];

// https://htmlcolorcodes.com/color-chart/
